<template>
  <div>
    <header-auth></header-auth>
    <div class="alto">
      <slot />
    </div>
    <app-footer></app-footer>
  </div>
</template>

<script>
import HeaderAuth from "./header/header-auth.vue";
import AppFooter from "./footer/footer.vue";

export default {
  components: {
    "app-footer": AppFooter,
    "header-auth": HeaderAuth,
  },
};
</script>

<style scoped>
@media only screen and (max-height: 900px) {
  .alto {
    min-height: 60vh;
  }
}
@media only screen and (max-height: 1000px) {
  .alto {
    min-height: 74.5vh;
  }
}

@media only screen and (min-height: 1001px) {
  .alto {
    min-height: 80vh;
  }
}
@media only screen and (min-height: 2001px) {
  .alto {
    min-height: 90vh;
  }
}
</style>